<template>
  <div>
    <div class="image-box">
      <img :src="image" @click="isShow = true" style="cursor: pointer;"/>
      <v-btn flat icon @click="$emit('onDelete', image)">
        <v-icon>delete</v-icon>
      </v-btn>
    </div>
    
    <preview-image @close="isShow = false" v-model="isShow">
      <img :src="image" slot="body" />
    </preview-image>
  </div>
</template>

<script>
import PreviewImage from '@/components/elements/PreviewImage'

export default {
  props: {
    image: {
      type: String,
      required: true
    },
    deletable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PreviewImage
  },
  data() {
    return {
      isShow: false
    }
  }
}
</script>

<style lang="scss" scoped>
  img {
    width: 100%;
  }

  .image-box {
    position: relative;

    > .v-btn {
      position: absolute;
      right: 0px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/elements/ImageEditable.vue